// https://github.com/typograf/jquery-typograf
import Typograf from "typograf";

export const autotypograf = (elem, prefs, disableRules = [], enableRules = []) => {
    prefs = prefs || {};
    prefs.live = true;

    var lastVal = elem.value,
        typograf = new Typograf(prefs);
    var cursorPosition = null;

    disableRules.forEach(rule => {
        typograf.disableRule(rule);
    })
    enableRules.forEach(rule => {
        typograf.enableRule(rule);
    })

    elem.addEventListener('keydown', function(e) {
        cursorPosition = getCaretPosition(elem) + 1;
        if (e.key === 'Backspace') {
            cursorPosition = elem.selectionStart === elem.selectionEnd ? cursorPosition - 2 : cursorPosition - 1;
        }
        if (e.key === 'Delete') {
            cursorPosition = cursorPosition - 1;
        }
    }, false);

    elem.addEventListener('input', function(e) {
        if (e.inputType === 'historyUndo') {
            return;
        }

        var val = elem.value;
        if (val !== lastVal) {
            lastVal = typograf.execute(val);
            elem.value = lastVal;

            if (cursorPosition !== null) {
                setCaretPosition(elem, cursorPosition === val.length ? lastVal.length : cursorPosition);
                //cursorPosition = null;
            }
        }

        elem.value = typograf.execute(lastVal);
    }, false);

    elem.addEventListener('paste', function(e) {
        var val = elem.value;
        cursorPosition = cursorPosition + e.clipboardData.getData('text/plain').length - 1;

        if (val !== lastVal) {
            lastVal = typograf.execute(val);
            elem.value = lastVal;

            if (lastVal === '') {
                cursorPosition = getCaretPosition(elem);
            }

            if (cursorPosition !== null) {
                setCaretPosition(elem, cursorPosition === val.length ? lastVal.length : cursorPosition);
                cursorPosition = null;
            }
        }

        elem.value = typograf.execute(lastVal);
    }, false);

    elem.addEventListener('click', function(e) {
        cursorPosition = getCaretPosition(elem)
    }, false);

    function getCaretPosition(elem) {
        return elem.selectionStart || 0;
    }

    function setCaretPosition(elem, pos) {
        elem.setSelectionRange && elem.setSelectionRange(pos, pos);
    }

    return typograf;
}
